export const dropdownButtonStyle = (accentColor, disabled) => ({
    background: disabled ? '#F5F6F7' : 'linear-gradient(to bottom, #ffffff, #F7F9FB)',
    border: `1px solid ${disabled ? '#DADCE0' : '#E8EAED'}`,
    borderRadius: 6,
    padding: '8px 14px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontWeight: 500,
    color: disabled ? '#BDC1C6' : '#202124',
    boxShadow: disabled ? 'none' : '0 2px 4px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06)',
    transition: 'all 0.2s ease',
    opacity: disabled ? 0.6 : 1
});

export const dropdownButtonHoverStyle = (accentColor) => ({
    transform: 'translateY(-1px)',
    boxShadow: `0 4px 6px rgba(0,0,0,0.1), 0 2px 4px ${accentColor}33`,
    borderColor: accentColor
});

export const dropdownMenuStyle = {
    position: 'absolute',
    top: '100%',
    left: 0,
    marginTop: 4,
    background: '#fff',
    border: '1px solid #DADCE0',
    borderRadius: 6,
    boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)',
    zIndex: 1000,
    minWidth: 180,
    padding: '4px 0'
};

export const menuItemStyle = (disabled) => ({
    display: 'block',
    width: '100%',
    padding: '8px 16px',
    textAlign: 'left',
    border: 'none',
    background: 'transparent',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontSize: 14,
    color: disabled ? '#BDC1C6' : '#3C4043',
    opacity: disabled ? 0.5 : 1,
    transition: 'background 0.15s ease'
});
